import { useGatewayCardContext } from '../gateway-card.context';
import CancellationDialog from '../dialogs/cancellation.dialog';

const MenuDialogs = () => {
    const {
        dialogs: { cancel },
    } = useGatewayCardContext();

    return <CancellationDialog open={cancel.isOpen} onClose={cancel.close} />;
};

export default MenuDialogs;
